import { render, staticRenderFns } from "./viewLicence.vue?vue&type=template&id=1c8a1b20"
import script from "./viewLicence.vue?vue&type=script&lang=js"
export * from "./viewLicence.vue?vue&type=script&lang=js"
import style0 from "./viewLicence.vue?vue&type=style&index=0&id=1c8a1b20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports